export default function AccessShell({
  error,
  isLoading,
  isUnauthorized,
  onSignIn,
  onSignOut,
}) {
  if (isUnauthorized) {
    return (
      <section className="cg-login-card">
        <div className="cg-brand-lockup">
          <span className="cg-kicker">Cologuard</span>
          <h1>Access has not been assigned</h1>
          <p>
            Your account is active, but it has not been assigned access to the
            Cologuard workspace. Contact an administrator for help.
          </p>
        </div>
        <div className="cg-login-form">
          <button type="button" onClick={onSignOut}>Sign Out</button>
        </div>
      </section>
    );
  }

  return (
    <section className="cg-login-card">
      <div className="cg-brand-lockup">
        <span className="cg-kicker">Cologuard</span>
        <h1>Sign in to continue</h1>
        <p>Use your approved Cologuard account to access the workspace.</p>
      </div>

      <div className="cg-login-form">
        {error ? <p className="cg-error-text">{error}</p> : null}
        {isLoading ? (
          <div className="cg-loading-block" aria-live="polite">
            <div className="cg-loading-bar" />
            <span>Signing you in...</span>
          </div>
        ) : null}
        <button type="button" onClick={onSignIn} disabled={isLoading}>
          {isLoading ? "Connecting..." : "Sign In"}
        </button>
      </div>
    </section>
  );
}
